/*
 * Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'toNow',
    standalone: false
})
export class ToNowPipe implements PipeTransform {

  transform(timestamp: number | string): string {
    return moment(timestamp).toNow(true);
  }
}
